import { createReducer } from "@reduxjs/toolkit";
import { resetUpdateTeacherStudio, updateTeacherStudio } from "./update-teacher-studio";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = {
  processing: "idle",
};

export const updateTeacherStudioReducer = createReducer(initialState, builder => {
  builder
    .addCase(updateTeacherStudio.pending, state => {
      state.processing = "pending";
    })
    .addCase(updateTeacherStudio.fulfilled, state => {
      state.processing = "success";
    })
    .addCase(updateTeacherStudio.rejected, state => {
      state.processing = "failed";
    })
    .addCase(resetUpdateTeacherStudio, () => {
      return initialState;
    });
});
